import { render, staticRenderFns } from "./success.vue?vue&type=template&id=54c60235&scoped=true&"
import script from "./success.vue?vue&type=script&lang=js&"
export * from "./success.vue?vue&type=script&lang=js&"
import style0 from "./success.vue?vue&type=style&index=0&id=54c60235&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c60235",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c60235')) {
      api.createRecord('54c60235', component.options)
    } else {
      api.reload('54c60235', component.options)
    }
    module.hot.accept("./success.vue?vue&type=template&id=54c60235&scoped=true&", function () {
      api.rerender('54c60235', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bind/success.vue"
export default component.exports